import classNames from 'classnames'
import { Cell } from './Cell'
import { EmptyRow } from './EmptyRow'

type Props = {
  guess: string
  isGameFinished: boolean
}

export const CurrentRow = ({ guess, isGameFinished }: Props) => {

  const classes = classNames(
    'w-80 h-8 border-solid border-2 flex items-center justify-center mx-0.5 text-lg font-bold rounded ',
    isGameFinished ? 'border-slate-600' : 'border-slate-200'
  )

  return (
    <div className="flex justify-center mb-1">
      <div className={classes}/>
    </div>
  )
}
